/**
 * @generated SignedSource<<4974ab8d4e792d62cd774bcbe2967e79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizListItemsTheme_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "69135be6dfc2cd42afbe82789f296dea";

module.exports = node;
